<script>
  import Service from '../../../../domain/leiloes/services'
  import * as Status from '../../../../domain/leiloes/helpers/LoteStatus'

  export default {
    name: 'copiar-lotes-view',
    data () {
      return {
        open: false,
        loading: true,
        leilaoId: null,
        leilaoNovoId: null,
        leiloes: [],
        lotes: [],
        selecionarTudo: false,
        isSending: false,
        pointer: -1,
        checkAllLotes: false
      }
    },
    computed: {
      getStatus () {
        return Status.Status
      }
    },
    mounted () {
    },
    destroyed () {
      this._unmount()
    },
    methods: {
      load (leilaoId, lotes) {
        console.log(lotes)
        this.lotes = lotes
        this.selecionarTudo = false
        let _body = document.querySelector('body')
        _body.classList.add('hide-scroll')
        this.leilaoId = leilaoId
        Service.checaLeiloesAbertos()
          .then((response) => {
            this.loading = false
            this.leiloes = response.data
            console.log(response)
          })
          .catch((error) => {
            window.responseError(error)
          })
        this.open = true
      },
      close () {
        this.open = false
        this._unmount()
      },
      _unmount () {
        this.htmlLoaded = false
        let _body = document.querySelector('body')
        _body.classList.remove('hide-scroll')
      },
      selectAll () {
        let checked = false
        this.$nextTick(() => {
          if (this.selecionarTudo) {
            checked = true
          }
          this.lotes.forEach((lote, index) => {
            // this.lotes[index].checked = checked
            this.$set(this.lotes, index, Object.assign({}, this.lotes[index], {checked: checked})) // Analisar desempenho
          })
        })
      },
      checkTipos (t, v) {
        this.$nextTick(() => {
          this.lotes.forEach((lote, index) => {
            // this.lotes[index].checked = checked
            if (parseInt(lote.status) === v) {
              this.$set(this.lotes, index, Object.assign({}, this.lotes[index], {checked: this.tipoEnvio[t]})) // Analisar desempenho
            }
          })
        })
      },
      enviar () {
        if (!this.leilaoNovoId) {
          alert('Selecione o leilão destino')
          return
        }
        console.log(this.leilaoNovoId)
        this.isSending = true
        // if (this.pointer >= 0) return
        this.pointer++
        if (this.pointer > (this.lotes.length - 1)) {
          this.isSending = false
          this.pointer = -1
          return
        }
        this.asyncSend(this.lotes[this.pointer], this.pointer)
      },
      asyncSend (lote, index) {
        if (lote.checked) {
          this.$set(this.lotes, index, Object.assign({}, this.lotes[index], {sending: true}))
          Service.copiarLote(this.leilaoId, this.leilaoNovoId, lote.id)
            .then((response) => {
              this.$set(this.lotes, index, Object.assign({}, this.lotes[index], {sending: false, sended: true}))
              this.enviar()
            })
            .catch((error) => {
              this.$set(this.lotes, index, Object.assign({}, this.lotes[index], {sending: false, sendedError: error}))
              this.enviar()
            })
        } else {
          this.enviar()
        }
      }
    },
    components: {}
  }
</script>

<template>
  <div>
    <div class="side-panel-overlay" @click="close" :class="{'open': open}">
    </div>
    <div class="view-container" :class="{'open': open}">
      <span @click="close" class="side-panel-close" title="Close">
        <span class="side-panel-close-inner"></span>
      </span>
      <span class="side-panel-print side-panel-print-visible" title="Print"></span>
      <div class="panel-rest wrapper overflow-auto">
        <div v-if="loading">
          Verificando... <i class="fa fa-spinner fa-spin"></i>
        </div>
        <div v-else>

          <div class="m-b row">
            Selecione o leilão de destino da cópia dos lotes:
            <br><br>
            <div v-for="leilao in leiloes">
              <input :id="'leilao' + leilao.id" type="radio" v-model="leilaoNovoId" :value="leilao.id"> <label
              :for="'leilao' + leilao.id">{{leilao.titulo}} / ID {{leilao.id}} / Data:
              {{moment(leilao.dataAbertura.date).format('L')}}
              {{moment(leilao.dataAbertura.date).format('LTS')}}</label>
            </div>
          </div>

          <div class="m-b row">
            <!--<div class="col-sm-8">
              <label class="i-checks m-b-none">
                <input type="checkbox" v-model="checkAllLotes" @click="checkTipos('vendidos', 6)" tabindex="0"
                       aria-checked="false"
                       aria-invalid="false"><i></i> Marcar todos
              </label>
              &nbsp; &nbsp
            </div>-->
            <div class="col-sm-12">
              <u-button :disabled="isSending" class="btn btn-dark pull-right" @click="enviar"><i
                class="fa fa-envelope m-r-xs"></i> Transferir como cópia
              </u-button>
            </div>
          </div>

          <table class="table table-clicked table-striped bg-white b-a">
            <thead>
            <tr>
              <th style="width: 30px">
                <label class="i-checks m-b-none">
                  <input type="checkbox" v-model="selecionarTudo" @click="selectAll" tabindex="0"
                         aria-checked="false"
                         aria-invalid="false"><i></i>
                </label>
              </th>
              <th>LT</th>
              <th>Título</th>
              <th>Comunicados</th>
              <th>Status</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="lote in lotes">
              <td>
                <label class="i-checks m-b-none">
                  <input type="checkbox" v-model="lote.checked" tabindex="0"
                         aria-checked="false"
                         aria-invalid="false"><i></i>
                </label>
              </td>
              <td>{{ lote.numero }}</td>
              <td>{{ lote.titulo }}</td>
              <td></td>
              <td style="background: #000000" :style="{'color': getStatus[lote.status].color}">{{
                getStatus[lote.status].titulo }}
                <div v-if="lote.sending" style="color: cyan"><i class="fa fa-spinner fa-spin"></i> Copiando</div>
                <div v-if="lote.sendedError" style="color: red">{{lote.sendedError}}</div>
                <div v-if="lote.sended" style="color: greenyellow" class="text-nowrap"><i class="fa fa-check"></i>
                  Copiado com sucesso!
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// CopiarLotesView.vue?626553a3